// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__6R_i6","box":"WorkspacesBox_box__5cbN1","node":"WorkspacesBox_node__2Tc1h"};